export default class merch {
  constructor(httpApi) {
    this.httpApi = httpApi;
  }

  // Définition du path
  pathHomeBlog(shopId) {
    return `api/magasins/${shopId}/blog`
  }

  async home(shopId) {
    const response = await this.httpApi.get(this.pathHomeBlog(shopId));
    return response.data;
  }

  pathArticle(shopId, articleId) {
    return `api/magasins/${shopId}/blog/${articleId}`
  }

  async article(shopId, articleId, params = {}) {
    const config = { ...this.httpApi.getConfig(), params };
    const response = await this.httpApi.get(this.pathArticle(shopId, articleId), config);
    return response.data;
  }
}
